"use client";
import { Url } from "next/dist/shared/lib/router/router";
import { PropsWithChildren } from "react";
import { useRouterChange } from "./useRouterChange";
// eslint-disable-next-line no-restricted-imports
import NextLink from "next/link";
import { useLang } from "@/providers/langProvider";
import { useRemoveLangFromPath } from "@/hooks/useRemoveLangFromPath";
interface Props {
  href: Url;
  onClick?: () => void;
  passHref?: boolean;
  prefetch?: boolean;
  skipCheckingForLang?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export const Link: React.FC<PropsWithChildren & Props> = ({
  href,
  passHref,
  onClick,
  children,
  skipCheckingForLang,
  style,
  className,
}) => {
  const routerChange = useRouterChange();
  const removeLangFromPath = useRemoveLangFromPath();
  const href1 = removeLangFromPath(
    href.toString(),
    skipCheckingForLang ? false : true,
  );
  const lang = useLang();
  return (
    <NextLink
      style={style}
      prefetch={false}
      passHref={passHref}
      href={href1.startsWith("http") ? href1 : `/${lang}${href1}`}
      onClick={() => {
        routerChange.setRouterChange(`/${lang}${href1}`);
        sessionStorage.removeItem("scrollPosition");
        onClick?.();
      }}
      className={className}
    >
      {children}
    </NextLink>
  );
};
